<template>
  <div class="fwdw">
    <ComponentHeader v-bind:index="index" />
    <div id="image" class="image">
      <div>SERVICE UNIT</div>
      <div>服务单位</div>
    </div>
    <div class="content">
      <div class="fwdw_title">部分服务单位（排名不分先后）</div>
      <div class="fwdw">
        <li class="line" style="margin-top: 0"></li>
        <div v-for="(item, index) of fwdw" :key="index">
          <img :src="item.imgUrl" :alt="item.mc" />
          <span>{{ item.mc }}</span>
          <li class="line"></li>
        </div>
      </div>
    </div>
    <div :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="seeMore">
      <button @click="back()">返回</button>
    </div>
    <ComponentFooter />
  </div>
</template>

<script>
import ComponentHeader from "../components/Header.vue";
import ComponentFooter from "../components/Footer.vue";

export default {
  components: { ComponentHeader, ComponentFooter },
  data() {
    return {
      index: "6",
      fwdw: [
        {
          imgUrl: require("../assets/image/tzsdermyy.png"),
          mc: "泰州市第二人民医院",
        },
        {
          imgUrl: require("../assets/image/czsdyrmyy.png"),
          mc: "常州市第一人民医院",
        },
        {
          imgUrl: require("../assets/image/sbrmyy.png"),
          mc: "江苏省苏北人民医院",
        },
        {
          imgUrl: require("../assets/image/txsrmyy.png"),
          mc: "泰兴市人民医院",
        },
        {
          imgUrl: require("../assets/image/tzsdsrmyy.png"),
          mc: "泰州市第四人民医院",
        },
        {
          imgUrl: require("../assets/image/gysrmyy.png"),
          mc: "高邮市人民医院",
        },
        {
          imgUrl: require("../assets/image/tzsjyzyy.png"),
          mc: "姜堰中医院",
        },
        {
          imgUrl: require("../assets/image/yzsdermyy.png"),
          mc: "扬州市第二人民医院",
        },
        {
          imgUrl: require("../assets/image/tzszyy.png"),
          mc: "泰州市中医院",
        },
      ],
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
.fwdw {
  .image {
    width: 100%;
    background: url("../assets/image/1-01-01.png") no-repeat;
    background-size: 100% 100%;
    height: 3.2rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    div {
      color: #d2f9e9;
      font-weight: 400;
      &:first-child {
        font-size: 0.18rem;
      }
      &:last-child {
        font-size: 0.15rem;
      }
    }
  }
  .content {
    font-size: 0.1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .fwdw_title {
      font-size: 0.15rem;
      font-weight: bold;
      margin: 22px 0 50px;
      color: #1f948d;
    }
    .fwdw {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      list-style: none;
      .line {
        width: 90%;
        border-bottom: 1px dashed #707070;
        margin: 44px 0;
      }
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;

        img,
        span {
          display: block;
        }
        img {
          width: 90%;
          // height: 50%;
        }
        span {
          margin: 25px 0 0 0;
        }
      }
    }
  }
  .seeMore {
    font-size: 0.7rem;
    display: flex;
    justify-content: center;
    margin: 0px 0 22px 0;
    button {
      width: 84px;
      height: 33px;
      background: #e6fffb;
      border-radius: 30px;
      color: #000;
      outline: 0;
      border: 0;
    }
  }
}
</style>